import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(() => ({
  text: {
    opacity: 0,
    WebkitAnimation: `$ellipsis-dot 2s infinite`,
    animation: `$ellipsis-dot 2s infinite`,
  },
  first: {
    WebkitAnimationDelay: '0.0s',
    animationDelay: '0.0s',
  },
  second: {
    WebkitAnimationDelay: '0.2s',
    animationDelay: '0.2s',
  },
  third: {
    WebkitAnimationDelay: '0.4s',
    animationDelay: '0.4s',
  },
  '@-webkit-keyframes ellipsis-dot': {
    '0%': { opacity: 0 },
    '50%': { opacity: 1 },
    '100%': { opacity: 0 },
  },
  '@keyframes ellipsis-dot': {
    '0%': { opacity: 0 },
    '50%': { opacity: 1 },
    '100%': { opacity: 0 },
  },
}));

const AnimatedEllipsis = ({ className }) => {
  const classes = useStyles();

  return (
    <Typography className={className}>
      <span className={`${classes.text} ${classes.first}`}>.</span>
      <span className={`${classes.text} ${classes.second}`}>.</span>
      <span className={`${classes.text} ${classes.third}`}>.</span>
    </Typography>
  );
};

export default AnimatedEllipsis;
